import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material'
import i18n from 'lang/idiomas'
/**
 * The DocumentTypeFilter component
 * @component
 *
 * @param {Object} props
 * @param {string} props.documentType
 * @param {function} props.handleChangeDocumentType
 * @returns {JSX.Element}
 */

const DocumentTypeFilter = ({ documentType, handleChangeDocumentType }) => {
  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <FormControl fullWidth>
        <Typography variant="body1">
          {i18n.t('efactura.tipodoc', { defaultValue: 'Tipo documento' })}
        </Typography>
        <Select
          sx={{
            width: '100%',
          }}
          displayEmpty
          size="small"
          value={documentType}
          onChange={(e) => {
            e.preventDefault()
            handleChangeDocumentType(e.target.value)
          }}
        >
          <MenuItem key="TDFC" value="FC">
            {i18n.t('efactura.tdfc', { defaultValue: 'Ingresos' })}
          </MenuItem>
          <MenuItem key="TDNC" value="NC">
            {i18n.t('efactura.tdnc', { defaultValue: 'Egresos' })}
          </MenuItem>
          <MenuItem key="TDAll" value="">
            {i18n.t('efactura.tdall', { defaultValue: 'Todos' })}
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  )
}

export default DocumentTypeFilter
